import React from 'react';
import { Input } from '../inputs';
import injectSheet from 'react-jss';
import styleSheet from './styles';

interface InputAIDisclaimer {
  value?: string;
  error?: boolean;
  label?: string;
  name: string;
  type: string;
  key?: string;
  classes?: any;
  placeholder?: string;
  onChange?: (e: object) => void;
  personalizationPillsShown?: boolean;
  personalizationCompleted: boolean;
}

const InputAIDisclaimer = ({
  value,
  error,
  label,
  name,
  type,
  key,
  classes,
  placeholder,
  onChange,
  personalizationPillsShown,
  personalizationCompleted,
}: InputAIDisclaimer) => {
  const disclaimer = `By initiating this action, you consent to the use of this application
  provided by OpenAI, our third-party service provider. EAB may record and
  maintain a transcript of this interaction. For further information about
  our information practices, please see our Privacy Policy`;

  return (
    <div
      style={{ visibility: personalizationPillsShown ? 'hidden' : 'visible' }}
    >
      <Input
        value={value}
        error={error}
        label={label}
        name={name}
        key={key}
        placeholder={placeholder}
        type={type}
        onChange={onChange}
        disabled={personalizationCompleted}
      />
      <div
        tabIndex={0}
        aria-label={disclaimer}
        className={classes.textContainer}
      >
        {disclaimer}
        <a
          aria-label="Privacy Policy"
          href="https://www.appily.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.linkText}
        >
          here
        </a>
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(InputAIDisclaimer);
